export const openSidePanelContentWidth = 'calc(100% - 280px)'
